<template>
  <v-data-table
    mobile-breakpoint="0"
    item-key="id"
    :options.sync="tableOptions"
    :server-items-length="count"
    :items-per-page="5"
    :headers="headers"
    :items="items"
    :footer-props="footerTable"
    v-bind="this.$attrs"
    disable-sort
  >
    <template v-slot:[`item.student`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>

    <template v-for="qh in questionHeaders" v-slot:[`item.${qh.value}`]="{ item }">
      <div :key="qh.value">
        {{ getAnswer(item, qh.value) }}
      </div>
    </template>

    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | ddmmyyyyhhmm }}
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { get } from 'lodash'

export default {
  components: { CardStudentName },
  data: () => ({ tableOptions: {} }),
  methods: {
    ...mapActions({
      requestPageSettings: 'studentSurvey/requestPageSettings',
    }),
    getAnswer(item = {}, questionId = '') {
      const answers = get(item, 'answers', [])
      if (Array.isArray(answers) && answers.length) {
        const answer = answers.find(a => a.question === questionId)
        return get(answer, 'answer.title', '--')
      }
      return '--'
    },
  },
  computed: {
    ...mapState('studentSurvey', ['count', 'items', 'pageText', 'loading']),
    ...mapState({
      questions: state => state.surveyQuestion.items,
    }),
    footerTable() {
      const footer = {
        'items-per-page-text': 'Số đăng ký mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    questionHeaders() {
      return this.questions.map((q, i) => ({ text: `Câu hỏi ${i + 1}: ${q.title}`, value: q.id }))
    },
    headers() {
      const headers = [
        { text: 'Học sinh', value: 'student' },
        { text: 'Trả lời lúc', value: 'createdAt', align: 'center' },
      ]
      headers.splice(1, 0, ...this.questionHeaders)
      return headers
    },
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
  },
}
</script>
